/* TZAMPAS Before/After-Slider — Progressive Enhancement.
   Ohne JS zeigt der Slider 50/50 (CSS-Default). Mit JS wird der Regler interaktiv.
   Pointer Events decken Maus, Touch und Stift ab; der versteckte Range-Input
   bleibt für Tastatur-Bedienung (A11y) erhalten. */
(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function init(el) {
    var range = el.querySelector('.tz-ba__range');

    var apply = function (pct) {
      el.style.setProperty('--tz-ba-pos', pct + '%');
      if (range && range.value != pct) range.value = pct;
      if (range) range.setAttribute('aria-valuenow', Math.round(pct));
    };

    // Tastatur / native Range-Bedienung
    if (range) {
      range.addEventListener('input', function () { apply(range.value); });
    }

    // Pointer-Drag (Maus + Touch + Stift) direkt auf dem Rahmen
    var dragging = false;

    var positionFromEvent = function (event) {
      var rect = el.getBoundingClientRect();
      if (!rect.width) return null;
      var pct = ((event.clientX - rect.left) / rect.width) * 100;
      return clamp(pct, 0, 100);
    };

    var onPointerDown = function (event) {
      // Nur primäre Taste / Touch
      if (event.button != null && event.button !== 0) return;
      dragging = true;
      if (el.setPointerCapture && event.pointerId != null) {
        try { el.setPointerCapture(event.pointerId); } catch (e) {}
      }
      var pct = positionFromEvent(event);
      if (pct != null) apply(pct);
      event.preventDefault();
    };

    var onPointerMove = function (event) {
      if (!dragging) return;
      var pct = positionFromEvent(event);
      if (pct != null) apply(pct);
      event.preventDefault();
    };

    var onPointerUp = function (event) {
      if (!dragging) return;
      dragging = false;
      if (el.releasePointerCapture && event.pointerId != null) {
        try { el.releasePointerCapture(event.pointerId); } catch (e) {}
      }
    };

    if (window.PointerEvent) {
      el.addEventListener('pointerdown', onPointerDown);
      el.addEventListener('pointermove', onPointerMove);
      el.addEventListener('pointerup', onPointerUp);
      el.addEventListener('pointercancel', onPointerUp);
    } else {
      // Fallback für sehr alte Browser ohne Pointer Events
      el.addEventListener('mousedown', onPointerDown);
      window.addEventListener('mousemove', onPointerMove);
      window.addEventListener('mouseup', onPointerUp);
      el.addEventListener('touchstart', function (e) {
        onPointerDown(e.touches[0]);
      }, { passive: false });
      el.addEventListener('touchmove', function (e) {
        if (dragging && e.cancelable) e.preventDefault();
        onPointerMove(e.touches[0]);
      }, { passive: false });
      el.addEventListener('touchend', onPointerUp);
    }

    // Startwert aus Range übernehmen (Default 50)
    apply(range ? range.value : 50);
  }

  function boot() {
    document.querySelectorAll('.tz-ba__frame').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
